<template>
	<b-popover
		:id="id"
		:ref="id"
		:placement="placement"
		trigger="manual"
		:custom-class="$attrs['class-list']"
		:target="target"
		:container="container"
	>
		<slot name="title" />
		<slot name="default" />
	</b-popover>
</template>

<script>
	function findPos(obj) {
		let curtop = 0;

		if (obj.offsetParent) {
			do {
				curtop += obj.offsetTop;
			} while ((obj = obj.offsetParent));

			return [curtop];
		}
	}

	export default {
		name: "BasePopover",
		props: {
			id: {
				type: String,
				required: true
			},
			status: {
				type: Boolean,
				required: true,
				default: false
			},
			targetId: {
				type: String,
				required: true
			},
			placement: {
				type: String,
				required: false,
				default: "right"
			},
			container: {
				type: String,
				required: false,
				default: "body"
			}
		},
		data() {
			return {
				target: ""
			};
		},
		watch: {
			status: {
				handler() {
					if (this.status) {
						setTimeout(() => {
							this.$refs[this.id].$emit("open");

							window.scroll({
								left: 0,
								top: findPos(this.target) - 100,
								behavior: "smooth"
							});
						}, 100);
					} else {
						setTimeout(() => {
							this.$refs[this.id].$emit("close");
						}, 100);
					}
				},
				immediate: true
			}
		},
		mounted() {
			let attempt = [];

			const existCondition = setInterval(() => {
				const elementById = document.getElementById(this.targetId);
				const querySelector = document.querySelector(`[${this.targetId}]`);

				if (!attempt[this.targetId]) {
					attempt[this.targetId] = 0;
				}

				attempt[this.targetId] += 1;

				if (elementById instanceof HTMLElement || querySelector instanceof HTMLElement) {
					this.target = elementById ?? querySelector;

					if (this.target) {
						// this.$emit("update:status", true);

						clearInterval(existCondition);

						if (this.status === true) {
							setTimeout(() => {
								this.$refs[this.id].$emit("open");

								window.scroll({
									left: 0,
									top: findPos(this.target) - 100,
									behavior: "smooth"
								});
							}, 100);
						}
					}
				}
			}, 1000);
		},
		destroyed() {
			// this.$emit("update:status", false);
		}
	};
</script>

<style lang="scss">
	.popover {
		border-radius: 8px;
		background: var(--white);
		border: 1px solid var(--border);
		box-shadow: 0px 0px 70px rgba(51, 77, 110, 0.31); // refracto : edit this
		width: 323px;
		max-width: 323px;
		padding: 22px 25px 11px 25px;

		&-header {
			background-color: var(--white);
			border-bottom: none;
			padding: 0;
			padding-bottom: 15px;
		}
	
		&-body {
			padding: 0;
			margin: 0;
			color: var(--black);
		}

		& .title {
			font-weight: 600;
			font-size: 15px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #323c47;
			margin-bottom: 15px;
		}

		& .box {
			width: 272px;
			background: #f9f9f9;
			border: 1px solid #e8e4e4;
			box-sizing: border-box;
			border-radius: 10px;
			text-align: center;
			margin: 0;
			margin-bottom: 8px;
			padding: 7px 16px 7px 16px;
		}

		& .box-dashed {
			@extend .box;
			border: 1px dashed #e8e4e4;
		}

		& .btn-action {
			width: 100%;
			height: 32px;
			border-radius: 4px;
			font-size: 13px;
			line-height: 19px;
			text-align: center;
			letter-spacing: 0.01em;
			margin-bottom: 8px;
		}

		& .input {
			height: 30px;
			border: 1px solid;
			border-radius: 5px;
			display: inline-block;
		}

		& .label {
			margin-bottom: 9px;
			font-size: 12px;
			line-height: 18px;
			letter-spacing: 0.01em;
			color: #192a3e;
		}

		.option-border {
			border: 1px solid var(--border) !important;
		}
	}

	.arrow::before,
	.bs-popover-right > .arrow::before {
		border-right-color: rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(0, 0, 0, 0.1);
	}
</style>
